/** Граница срока хранения, как её присылает `/timeline`. */
export interface RetentionIn {
  s3_days: number;
  /** RFC 3339: раньше этого момента записи удалены по сроку. */
  cutoff: string;
}

export interface Retention {
  days: number;
  cutoff: number;
}

export function parseRetention(raw: RetentionIn | null | undefined): Retention | null {
  if (!raw) return null;
  const cutoff = Date.parse(raw.cutoff);
  return Number.isFinite(cutoff) ? { days: raw.s3_days, cutoff } : null;
}

/**
 * Часть интервала, лежащая за границей срока хранения.
 *
 * Вынесено из отрисовки, потому что именно здесь легко ошибиться на краях:
 * граница левее окна, правее окна, внутри. `null` — серого в окне нет.
 */
export function retentionBand(
  from: number,
  to: number,
  retention: Retention | null,
): { start: number; end: number } | null {
  if (!retention || to <= from || retention.cutoff <= from) return null;
  return { start: from, end: Math.min(retention.cutoff, to) };
}

export function isBeyond(ms: number, retention: Retention | null): boolean {
  return retention !== null && ms < retention.cutoff;
}

/** Подпись для момента за границей срока. */
export function beyondRetention(days: number): string {
  return `за пределами срока хранения (${days} дн.)`;
}
